import { Component, Input, OnInit, HostListener, Output, EventEmitter } from '@angular/core';
import { LanguageService } from 'src/services/language.service';
import { TranslateService } from '@ngx-translate/core';
import { Role } from 'src/model/model.role'; // Ensure this model is defined

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone: false,
})
export class SidebarComponent implements OnInit {
  @Input() isEtabSelected: boolean = false;
  @Input() inscritsEnv?: string;
  @Input() personnels?: string;
  @Input() personnel?: string;
  @Input() isSidebarOpen: boolean = false;
  @Output() itemClicked = new EventEmitter<void>();

  isMobile: boolean = window.innerWidth <= 768;
  isLargeScreen: boolean = window.innerWidth > 1024; // Define isLargeScreen
  public isCollapsedFam = true;
  public isCollapsedE = true;
  public isCollapsedPers = true;
  public isCollapsedSt = true;
  public isCollapsedEnt = true;
  public isCollapsedStat = true;
  public isCollapsedF = true;

  // Role-related properties
  isUserRole: boolean = false;
  isAdminOrSuperAdmin: boolean = false;

  constructor(
    private translate: TranslateService,
    public languageService: LanguageService
  ) {}

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.isMobile = window.innerWidth <= 768;
    this.isLargeScreen = window.innerWidth > 1024;
  }

  ngOnInit() {
    this.languageService.currentLang$.subscribe(lang => {
    });

    // Check user roles on initialization
    this.checkUserRole();
  }

  checkUserRole(): void {
    const authUser = JSON.parse(sessionStorage.getItem('authUser') || '{}');
    const userRoles: Role[] = authUser?.roles || [];

    // Check if the user has only the USER role
    this.isUserRole = userRoles.length === 1 && userRoles.some(role => role.roleName === 'USER');

    // Check if the user has ADMIN or SUPER_ADMIN role
    this.isAdminOrSuperAdmin = userRoles.some(
      role => role.roleName === 'ADMIN' || role.roleName === 'SUPER_ADMIN'
    );
  }

  toggleCollapse(section: string) {
    switch (section) {
      case 'fam':
        this.isCollapsedFam = !this.isCollapsedFam;
        break;
      case 'bene':
        this.isCollapsedE = !this.isCollapsedE;
        break;
      case 'pers':
        this.isCollapsedPers = !this.isCollapsedPers;
        break;
      case 'dep':
        this.isCollapsedSt = !this.isCollapsedSt;
        break;
      case 'rec':
        this.isCollapsedEnt = !this.isCollapsedEnt;
        break;
      case 'stat':
        this.isCollapsedStat = !this.isCollapsedStat;
        break;
      case 'fact':
        this.isCollapsedF = !this.isCollapsedF;
        break;
    }
    if (this.isMobile && this.isSidebarOpen) {
      this.itemClicked.emit();
    }
  }

  onItemClick() {
    if (this.isMobile && this.isSidebarOpen) {
      this.itemClicked.emit();
    }
  }
}
